.header {
    display: flex;
    flex-direction: column;
    gap: var(--exo-spacing-small);
    margin: 0 0 var(--exo-spacing-medium);
}

.heading {
    margin: 0;
    font-weight: var(--exo-font-weight-bold);
}

.empty {
    display: flex;
    justify-content: center;
    padding: var(--exo-spacing-2x-large) var(--exo-spacing-large);
    border: 1px dashed var(--exo-color-border-secondary);
    border-radius: 10px;
}

.grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: var(--exo-spacing-standard);
    align-content: stretch;
    justify-content: stretch;
}

.cardAdd {
    display: grid;
    gap: var(--exo-spacing-small);
    cursor: pointer;
    align-content: center;
    justify-content: center;
    background-color: var(--exo-color-background);
    border: 1px solid var(--exo-color-border-secondary);
    border-radius: var(--exo-radius-large);
    box-shadow: var(--exo-box-shadow-weak);
    transition: box-shadow var(--exo-time-standard) var(--exo-curve-smooth);
    padding: var(--exo-spacing-standard);
    font: unset;

    &:hover {
        box-shadow: var(--exo-box-shadow-moderate);
    }

    &:focus-visible {
        outline: 2px solid var(--exo-color-border-tertiary);
        outline-offset: -2px;
    }
}

.addIcon {
    justify-self: center;
}

.addTitle {
    font: var(--exo-text-body-standard);
    font-weight: var(--exo-font-weight-semi-bold);
}

.addDescription {
    font: var(--exo-text-body-small);
    color: var(--exo-color-font-secondary);
    max-width: 28ch;
}
